<template>
<div>
<!--
<div class="custom-file_">
    <input ref="inputFile" class="form-control" type="file"   @click="resetInputFile()" @change="previewFile($event)" />
</div>
-->

<div class="custom-file">
  
  <input accept=".csv"  :disabled="type=='disabled'" :placeholder="'filename'" ref="inputFile" type="file" class="custom-file-input" id="customFile"  @click="resetInputFile()" @change="previewFile($event)">
  <label class="custom-file-label" data-browse="SCEGLI FILE" for="customFile">{{ filename ? filename :'Caricamento da file' }}</label>
  
</div>


</div>
</template>
<script>

export default {

  props      : ['type','typeId'],
     
 data () {
    return {
      filename: ''
    }
  },
  computed: {
 
  },
mounted()
{

},  

created()
{
  
},
methods :
{
    resetInputFile()
    {
     
      const items = []
      this.$refs["inputFile"].value = "";
      this.$emit('update',items)
      this.filename = ''
      
    },

    previewFile(evt) 
    {
      
      const file = evt.target.files[0];
      const reader = new FileReader();

      reader.addEventListener(
        "load",() => 
      {
      
        //const items = reader.result.split('\r\n')              
        const items = reader.result
       
        const barcodes = this.setData(items)
      
        if(barcodes.length > 0)
        {
          
          this.$emit('update',barcodes)
        }
      
      
      },
      false
      )

      reader.addEventListener("error", () => {
        console.error(`Error occurred reading file: ${file.name}`);
      });

      if (file) 
      {
        this.filename = file.name
        reader.readAsText(file);
      }

    },
  

  csvToArray2(str,headers, delimiter = ",") {
  // slice from start of text to the first \n index
  // use split to create an array from string by delimiter

  //const headers = str.slice(0, str.indexOf("\n")).split(delimiter);

  // slice from \n index + 1 to the end of the text
  // use split to create an array of each csv value row
  const rows = str.slice(str.indexOf("\n") + 1).split(/\r?\n/);

  // Map the rows
  // split values from each row into an array
  // use headers.reduce to create an object
  // object properties derived from headers:values
  // the object passed as an element of the array
  const arr = rows.map(function (row) {
    const values = row.split(delimiter);
    const el = headers.reduce(function (object, header, index) {
      object[header] = values[index];
      return object;
    }, {});
    return el;
  });

  // return the array
  return arr;
},




  csvToArray(data,headers,delimiter = ',') {
  
  const lines = data.split(/\r?\n/)
  
  const result = [];

  //const headers = lines[0].split(',');

  for (let i = 1; i < lines.length; i++) {
    
    const obj = {};
    const currentline = lines[i].split(delimiter)  
    headers.forEach((header, index) => {    
      obj[header] = currentline[index]     
    });

    result.push(obj);
  }
  
  return result
  
  },


  
  setData(items)
  {
   

    const check = 0
    let barcodes = []
    if(this.type == 'PriceListUpdate')
    {
        const headers = []
        if(this.typeId == 1 )
        {
          headers.push('barcode')
        }
        else if(this.typeId == 2)
        {
          headers.push('barcode')
          headers.push('discount')
          
        }
        else if(this.typeId == 3)
        {
          headers.push('barcode')
          headers.push('price')
          
        }
        
       
        //barcodes = this.processData(items,headers)  
        barcodes = this.csvToArray(items,headers)  
        

        
       
    /*  
    items.forEach(item => {
         
         if(Number(item) > 0)
         {
           const ean = item.toString().substr(0,13)
           if(isNaN(ean))
           {
            check++
           }
           barcodes.push({'barcode':Number(ean)})
         }

       
     })
     */ 
    }
    else if (this.type == 'EanSupplierUpdate')
    {
      items.forEach(item =>{
         
         
          const barcode = item.toString().substr(0,13)
          const ean     = item.toString().substr(14,13)
          if(isNaN(ean) || isNaN(barcode))
           {
            check++
           }  
          barcodes.push({'barcode' : Number(barcode),'ean' : Number(ean)})
                
     })
     
     
    }
    else if (this.type == 'stockMatching')
    {
      items.forEach(item =>{
         
         
          const barcode = item.toString().substr(0,13)
         
          if(isNaN(barcode))
           {
            check++
           }  
          barcodes.push({'barcode' : Number(barcode)})
                
     })
     
     
    }
    else if (this.type == 'test')
    {
      items.forEach(item =>{
         
          const cols = item.split(';');
          
         
                
     })
     
     
    }
    if(check)
     {
      return []
     }
     else
     {
      return barcodes 
     }
    

  }

}

}

</script>
<style scoped>
.custom-file-input
{
  cursor: pointer;
}

</style>